import { autocomplete } from '@algolia/autocomplete-js';


document.addEventListener( 'DOMContentLoaded', function() {

    function debouncePromise(fn, time){
        let timerId = undefined
        
        return function(...args){
            if(timerId){
                clearTimeout(timerId)
            }        
            return new Promise((resolve) => {
                timerId = setTimeout(() => resolve(fn(...args)), time)
            })        
        }
    }
    const debouncedFetch = debouncePromise(fetch, 300)    

    if(document.getElementById("searchField")){
  
        autocomplete({
            container: '#searchField',
            placeholder: 'Search for products',
            //debug: true,
            
            getSources({query}){
                return debouncedFetch(`/ajax/search?q=${query}`)
                    .then(response => response.json())
                    .then((data) => {
                        return [
                            {
                                sourceId: "lines",
                                getItems(){
                                    return data
                                }, 
                                getItemUrl({ item }) {
                                    return `/product/shop/${item.Id}/${seoURL(item.name)}`
                                },                           
                                templates: {
                                    item({ item, html }){ 
                                        return html`<a href="/product/shop/${item.Id}/${seoURL(item.name)}" class="search-link">
                                            <div class="row align-items-center" onClick="window.location.href='/product/shop/${item.Id}/${seoURL(item.name)}'">
                                                <div class="col-auto">
                                                    <img src="${getImage(item.imgID)}" width="60" />
                                                </div>
                                                <div class="col">
                                                    ${item.name}                                                
                                                </div>
                                                <div class="col-auto text-end">£${getPrice(item.offer_price)}</div>
                                            </div>
                                        </a>`
                                    },
                                    // footer(){
                                    //     return "FOOTER"
                                    // },
                                    noResults(){
                                        return "No results"
                                    }
                                }
                            }
                        ]                
                    })
            }
        });
    
    }

    function getImage(filename){
        if(filename==0){
            return "/assets/images/no-image-s.jpg"
        } else {
            return `https://nuenta.com/product_pics/${filename}.jpg`
        }
    }
    
    function getPrice(minPrice){
            if(minPrice==0){return ' CALL';}else{ return minPrice.toFixed(2);}
    }
    function seoURL(url) {
        return url.toString()               // Convert to string
            .normalize('NFD')               // Change diacritics
            .replace(/[\u0300-\u036f]/g,'') // Remove illegal characters
            .replace(/\s+/g,'-')            // Change whitespace to dashes
            .toLowerCase()                  // Change to lowercase
            .replace(/&/g,'-and-')          // Replace ampersand
            .replace(/[^a-z0-9\-]/g,'')     // Remove anything that is not a letter, number or dash
            .replace(/-+/g,'-')             // Remove duplicate dashes
            .replace(/^-*/,'')              // Remove starting dashes
            .replace(/-*$/,'');             // Remove trailing dashes
    }    


});